import { Button } from "@/components/ui/UIElements/Button";
import React, { useState } from "react";
import { Icon } from "../";

const IntegrationFilters = ({
  searchTerm,
  onSearchChange,
  placeholder = "Search by name...",
}) => {
  const [localSearchTerm, setLocalSearchTerm] = useState(searchTerm || "");

  const handleSearchChange = (e) => {
    const value = e.target.value;
    setLocalSearchTerm(value);
    onSearchChange(value);
  };

  const handleClearSearch = () => {
    setLocalSearchTerm("");
    onSearchChange("");
  };

  return (
    <div className="border-border bg-background mb-6 rounded-lg border p-4">
      <div className="flex flex-col gap-4 lg:flex-row lg:items-center lg:justify-between">
        {/* Left side - Search */}
        <div className="flex flex-1 flex-col gap-4 sm:flex-row">
          {/* Search Input */}
          <div className="min-w-0 flex-1">
            <div className="relative">
              <div className="pointer-events-none absolute top-1/2 left-3 flex -translate-y-1/2 transform items-center">
                <Icon name="Search" className="text-muted-foreground h-5 w-5" />
              </div>
              <input
                type="text"
                placeholder={placeholder}
                value={localSearchTerm}
                onChange={handleSearchChange}
                className="border-border bg-card focus:ring-ring h-10 w-full rounded-lg border px-4 py-2 pr-10 pl-10 text-white placeholder-gray-400 focus:border-transparent focus:ring-2 focus:outline-none"
              />
              {localSearchTerm && (
                <Button
                  variant="ghost"
                  onClick={handleClearSearch}
                  className="bg-muted hover:bg-muted absolute top-1/2 right-2 flex h-5 w-5 -translate-y-1/2 transform cursor-pointer items-center justify-center rounded-full transition-colors"
                  type="button"
                >
                  <svg
                    className="text-foreground h-3 w-3 hover:text-white"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M6 18L18 6M6 6l12 12"
                    />
                  </svg>
                </Button>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default IntegrationFilters;
